import React from 'react';
import {Tag} from "../../models/Tags";
import DraggableModal from "../UI/DraggableModal";
import {Button, Modal} from "react-bootstrap";

interface TagRestrictionsModal{
    onHide: () => void,
    restrictions: Pick<Tag, 'groups' | 'users'> | null
}

export default function TagRestrictionsModal({onHide, restrictions}: TagRestrictionsModal){
    return <DraggableModal show={!!restrictions} onHide={onHide} headerNode='Видимость тега' size='lg'>
        <Modal.Body className='d-flex flex-column gap-4'>
            {restrictions?.groups.length !== 0 && <div>
              <h3 className='mb-3' style={{fontWeight: 600}}>Ролевые группы:</h3>
              <div className='d-flex flex-column gap-2'>
                  {restrictions?.groups.map(group => <span>{group.title}</span>)}
              </div>
            </div>}
            {restrictions?.users.length !== 0 && <div>
              <h3 className='mb-3' style={{fontWeight: 600}}>Пользователи:</h3>
              <div className='d-flex flex-column gap-2'>
                  {restrictions?.users.map(user => <span>{user.displayName}</span>)}
              </div>
            </div>}
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-end'>
        <Button variant='outline-primary' onClick={onHide}>OK</Button>
        </Modal.Footer>
    </DraggableModal>
}
